import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};
const initialMapChildState = {
  map: undefined,
  mapContainerRef: undefined,
  mapStyle: 'mapbox://styles/mapbox/streets-v11',
  setSource: noop,
  getSource: () => undefined,
  removeSource: noop,
  isSourceDefined: () => false,
  isMapDestroyed: () => false,
  setBounds: noop,
  debug: false
};
const MapChildContext = /*#__PURE__*/React.createContext(initialMapChildState);
const initialSourceChildState = {
  map: undefined,
  mapStyle: 'mapbox://styles/mapbox/streets-v11',
  sourceKey: undefined,
  isSourceDefined: () => false,
  isMapDestroyed: () => false,
  managed: true,
  setLayer: noop,
  getLayer: () => undefined,
  removeLayer: noop,
  debug: false
};
const SourceChildContext = /*#__PURE__*/React.createContext(initialSourceChildState);

export { MapChildContext, SourceChildContext };
//# sourceMappingURL=context.js.map
